import React from 'react';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { roundFloat } from 'src/core/utils/formater';

export const columns = () => [
  {
    title: '№',
    align: 'center',
    dataIndex: 'id',
    width: 50,
    render: (_, __, index) => index + 1,
  },
  {
    title: 'Даатгуулагчийн',
    align: 'center',
    children: [
      {
        title: 'Эцэг/ эхийн нэр',
        align: 'left',
        dataIndex: 'etseg_eh',
        width: 100,
      },
      {
        title: 'Нэр',
        align: 'left',
        dataIndex: 'ner',
        width: 100,
      },
      {
        title: 'Регистрийн дугаар',
        align: 'left',
        dataIndex: 'reg_num',
        width: 100,
      },
      {
        title: 'Даатгуулагчийн төрөл',
        align: 'left',
        dataIndex: 'daatgal_turul',
        width: 100,
      },
      {
        title: 'Ажил мэргэжлийн ангилал',
        align: 'left',
        dataIndex: 'ajil_mergejil',
        width: 100,
      },
      {
        title: 'Хөдөлмөрийн хөлс, түүнтэй адилтгах орлого ',
        align: 'right',
        dataIndex: 'orlogo',
        width: 100,
        render: (_, row) => roundFloat(row.orlogo),
      },
    ],
  },
  {
    title: 'Ногдуулсан шимтгэл /төгрөг/',
    align: 'center',
    children: [
      {
        title: 'Нийт дүн',
        align: 'right',
        dataIndex: 'niit_dun',
        width: 100,
        render: (_, row) => roundFloat(row.niit_dun),
      },
      {
        title: 'Үүнээс:',
        align: 'center',
        children: [
          {
            title: 'Ажил олгогч',
            align: 'right',
            dataIndex: 'ajil_olgogch',
            width: 100,
            render: (_, row) => roundFloat(row.ajil_olgogch),
          },
          {
            title: 'Даатгуулагч',
            align: 'right',
            dataIndex: 'daatguulagch',
            width: 100,
            render: (_, row) => roundFloat(row.daatguulagch),
          },
        ],
      },
    ],
  },
  {
    title: 'Даатгуулагчийн',
    align: 'center',
    children: [
      {
        title: 'Харилцах утасны дугаар',
        align: 'center',
        dataIndex: 'phone_number',
        width: 100,
      },
      {
        title: 'Цахим шуудангийн хаяг',
        align: 'center',
        dataIndex: 'email',
        width: 100,
      },
    ],
  },
];

export const customSummary = [
  {
    align: 'center',
    word: '',
  },
  {
    align: 'left',
    word: 'Нийт дүн:',
  },
  {
    align: 'center',
  },
  {
    align: 'center',
    word: '',
  },
  {
    align: 'center',
  },
  {
    align: 'center',
  },
  {
    align: 'right',
    value: 'orlogo',
  },
  {
    align: 'right',
    value: 'niit_dun',
  },
  {
    align: 'right',
    value: 'ajil_olgogch',
  },
  {
    align: 'right',
    value: 'daatguulagch',
  },
  {
    align: 'center',
  },
  {
    align: 'center',
  },
];
